<template>
  <div style="">

    <el-dropdown size="small" class="d2-mr">
      <span class="btn-text">你好 {{ info.name }}</span>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="logOff">
          <d2-icon name="power-off" class="d2-mr-5" /> 注销
        </el-dropdown-item>
        <el-dropdown-item @click.native="updatePwd">
          <d2-icon name="unlock-alt" class="d2-mr-5" />修改密码
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      title="提示"
      :visible.sync="updateDialogVisible"
      width="30%"
      center
    >
      <el-form ref="ruleForm" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="旧密码" prop="oldPwd">
          <el-input
            type="password"
            show-password
            v-model="form.oldPwd"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input
            type="password"
            show-password
            v-model="form.newPwd"
          ></el-input>
        </el-form-item>
        <el-form-item label="二次新密码" prop="secPwd">
          <el-input
            type="password"
            show-password
            v-model="form.secPwd"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="update('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { updatePwd } from "@/api/admin/user";
import { cancelSend } from "@/api/czManager/czMessage/index";
import { getEmailNotify } from "@/api/czManager/czMessage/index";
export default {
  computed: {
    ...mapState("d2admin/user", ["info"]),
  },
  data() {
    return {
      updateDialogVisible: false,
      messageLen: 0,
      drawer: false,
      messageList: [],
      form: {
        oldPwd: "",
        newPwd: "",
        secPwd: "",
      },
      ruleForm: {
        oldPwd: "",
        newPwd: "",
        secPwd: "",
      },
      rules: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        secPwd: [
          { required: true, message: "请二次输入新密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    closeAllMessage() {
      let len = this.messageList.length;
      for (let i = 0; i < len; i++) {
        this.closeMessage(
          this.messageList[i].taskId,
          this.messageList[i].title,
        );
      }
    },
    closeMessage(taskId, title, index) {
      cancelSend(taskId, title).then((response) => {
        if (response.statusCode == 2000) {
          //取消成功
          this.$message({
            duration: 5000,
            message: response.message,
            type: "success",
          });
          delete this.messageList.splice(index);
        }
      });
    },
    showMessage() {
      this.drawer = true;
      console.log(this.drawer, "ssssssssssssss");
    },

    ...mapActions("d2admin/account", ["logout"]),
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        vm: this,
        confirm: true,
      });
    },
    updatePwd() {
      this.updateDialogVisible = true;
    },
    update(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.secPwd != this.form.newPwd) {
            this.$message.error("两次密码不一致");
            return;
          }
          updatePwd(this.form.oldPwd, this.form.newPwd).then((res) => {
            if (res.statusCode == 40103) {
              this.$message.error("密码错误");
            } else {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.updateDialogVisible = false;
            }
            console.log("res", res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    
  },
};
</script>
<style scoped>

</style>